import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { DESVINCUAL_PACIENTE_SAP } from "../../../../data/graphQL/mutations/SoporteHC/paciente";
import { useMutationHandler } from "../../hooks/useMutationHandler";

export default function DesvincularPacienteSAPForm() {
    const inputFields = [
        {
            name: 'idPaciente',
            type: 'int',
            displayName: 'HC Paciente',
            size: 2,
            required: true,
            placeholder: 'Ingrese HC Paciente'
        },
    ];

    const { values, handleChange, handleSubmit, loading } =
        useMutationHandler({
            initialValues: {
                idPaciente: '',
            },
            mutation: DESVINCUAL_PACIENTE_SAP,
            onSuccess: (data) => {
                if (data.desvincualPacienteSAP.error) {
                    toast.error(data.desvincualPacienteSAP.error);
                }

                if (data.desvincualPacienteSAP.success)
                    toast.success('Se desvinculó el código SAP del paciente correctamente.');
            }
        });

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => (
                    <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                        <RenderInputByTypeMobile
                            input={input}
                            value={values[input.name]}
                            handleChange={handleChange}
                        />
                    </Grid>
                ))}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >Aceptar</CustomButton>
                </Grid>
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
